@if (datePickerType !== 'default') {
  <div
    class="flex items-center flex-col space-y-2 pb-2 md:pb-0 md:space-y-0 md:flex-row transition"
    [ngClass]="{
      'has-preset': presetOptions.length > 0,
      'ring ring-primary border-transparent': focused && presetOptions.length > 0,
    }"
  >
    @if (presetOptions.length > 0) {
      <ion-list class="hidden md:block">
        <ion-item>
          <ion-select
            aria-label="Date Preset"
            class="text-xs font-normal"
            interface="popover"
            toggleIcon="chevron-down"
            (ionChange)="presetEvent($event)"
            placeholder="Select Range"
            [selectedText]="customDateActive ? 'Custom' : selectedPreset.label"
            [value]="customDateActive ? null : selectedPreset"
          >
            @for (option of presetOptions; track $index) {
              <ion-select-option class="text-xs font-medium mx-2 rounded" [value]="option">{{
                option.label
              }}</ion-select-option>
            }
          </ion-select>
        </ion-item>
      </ion-list>
    }
    <div class="flex items-center px-2">
      @if ((datePickerType == 'dateRange' || datePickerType == 'fromDate') && selectedFromDate) {
        <ion-datetime-button
          id="from-date-trigger-{{ datePickerId }}"
          datetime="from-date-selector-{{ datePickerId }}"
          [disabled]="disabled"
        >
          @if (presentationType == 'month-year') {
            <span slot="date-target">{{ selectedFromDate | amDateFormat: 'MMM YYYY' }}</span>
          }
        </ion-datetime-button>
      }
      @if ((datePickerType == 'dateRange' || datePickerType == 'fromDate') && !selectedFromDate) {
        <div
          class="cursor-pointer flex items-center hover:bg-grey-light-concrete rounded py-2 pl-2 text-grey-mid"
          id="from-date-trigger-{{ datePickerId }}"
          (click)="fromDatePopover?.present()"
        >
          dd/mm/yyyy
          <ion-icon class="mx-2 text-xl" name="calendar-outline"></ion-icon>
        </div>
      }
      @if (datePickerType == 'dateRange') {
        <span class="mx-2"> to </span>
      }
      @if ((datePickerType == 'dateRange' || datePickerType == 'toDate') && selectedToDate) {
        <ion-datetime-button
          id="to-date-trigger-{{ datePickerId }}"
          datetime="to-date-selector-{{ datePickerId }}"
          [disabled]="disabled"
        >
          @if (presentationType == 'month-year') {
            <span slot="date-target">{{ selectedToDate | amDateFormat: 'MMM YYYY' }}</span>
          }
        </ion-datetime-button>
      }
      @if ((datePickerType == 'dateRange' || datePickerType == 'toDate') && !selectedToDate) {
        <div
          class="cursor-pointer flex items-center hover:bg-grey-light-concrete rounded py-2 pl-2 text-grey-mid"
          id="to-date-trigger-{{ datePickerId }}"
          (click)="toDatePopover?.present()"
        >
          dd/mm/yyyy
          <ion-icon class="mx-2 text-xl" name="calendar-outline"></ion-icon>
        </div>
      }
    </div>
    @if (!autoSelectCustomDate) {
      <button
        id="datepicker-apply-btn"
        [disabled]="datePickerType == 'dateRange' && !selectedFromDate && !selectedToDate"
        class="mx-2 btn-xs hidden md:block"
        (click)="emitDateSelection()"
      >
        Apply
      </button>
    }
    @if (datePickerType == 'dateRange' || datePickerType == 'fromDate') {
      <ion-popover
        #fromDatePopover
        id="from-date-popover-{{ datePickerId }}"
        trigger="from-date-trigger-{{ datePickerId }}"
        [keepContentsMounted]="true"
        [isOpen]="isOpen"
        (didDismiss)="isOpen = false"
      >
        <ng-template>
          <ion-datetime
            #fromDateSelector
            id="from-date-selector-{{ datePickerId }}"
            [presentation]="presentationType"
            (ngModelChange)="selectFromDate($event)"
            [(ngModel)]="selectedFromDate"
            [showDefaultButtons]="true"
            [showClearButton]="true"
            [max]="maxDate"
          >
            <div class="flex w-full gap-2 justify-end" slot="buttons">
              @if (!!selectedFromDate) {
                <button
                  class="btn-danger-secondary mr-auto"
                  (click)="fromDateSelector.cancel(true); selectedFromDate = undefined"
                >
                  Clear
                </button>
              }
              <button class="btn-default" (click)="fromDateSelector.cancel(true)">Cancel</button>
              <button class="btn-primary" (click)="fromDateSelector.confirm(true)">Done</button>
            </div>
          </ion-datetime>
        </ng-template>
      </ion-popover>
    }
    @if (datePickerType == 'dateRange' || datePickerType == 'toDate') {
      <ion-popover
        #toDatePopover
        id="to-date-popover-{{ datePickerId }}"
        trigger="to-date-trigger-{{ datePickerId }}"
        [keepContentsMounted]="true"
        [isOpen]="isOpen"
        (didDismiss)="isOpen = false"
      >
        <ng-template>
          <ion-datetime
            #toDateSelector
            id="to-date-selector-{{ datePickerId }}"
            [presentation]="presentationType"
            (ngModelChange)="selectToDate($event)"
            [(ngModel)]="selectedToDate"
            [showDefaultButtons]="true"
            [showClearButton]="true"
            [max]="maxDate"
          >
            <div class="flex w-full gap-2 justify-end" slot="buttons">
              @if (!!selectedToDate) {
                <button
                  class="btn-danger-secondary mr-auto"
                  (click)="toDateSelector.cancel(true); selectedToDate = undefined"
                >
                  Clear
                </button>
              }
              <button class="btn-default" (click)="toDateSelector.cancel(true)">Cancel</button>
              <button class="btn-primary" (click)="toDateSelector.confirm(true)">Done</button>
            </div>
          </ion-datetime>
        </ng-template>
      </ion-popover>
    }
  </div>
} @else {
  <div class="inline-flex items-center">
    <ion-datetime-button
      id="date-trigger-{{ datePickerId }}"
      datetime="date-selector-{{ datePickerId }}"
      [disabled]="disabled"
    >
      @if (!selectedDate) {
        <div class="flex items-center text-grey-mid text-sm" slot="date-target">
          dd/mm/yyyy
          <ion-icon class="ml-2 size-4" name="calendar-outline"></ion-icon>
        </div>
      }
    </ion-datetime-button>
    @if (removableDate && selectedDate) {
      <button class="btn-icon btn-right text-bright-crimson m-0" tooltip="Clear Date" (click)="removeDate()">
        <ion-icon name="remove-circle"></ion-icon>
      </button>
    }
    <ion-popover
      #datePopover
      id="date-popover-{{ datePickerId }}"
      [trigger]="'date-trigger-' + datePickerId"
      [keepContentsMounted]="true"
      [isOpen]="isOpen"
      (didDismiss)="isOpen = false"
    >
      <ng-template>
        <ion-datetime
          id="date-selector-{{ datePickerId }}"
          #dateSelector
          [presentation]="presentationType"
          [max]="maxDate"
          [min]="minDate"
          [showDefaultButtons]="true"
          [showClearButton]="true"
          (ngModelChange)="selectDate($event)"
          [(ngModel)]="selectedDate"
        >
          <div class="flex w-full gap-2 justify-end" slot="buttons">
            @if (!!selectedDate) {
              <button
                class="btn-danger-secondary mr-auto"
                (click)="dateSelector.cancel(); datePopover.dismiss({}, 'clear', false); removeDate()"
              >
                Clear
              </button>
            }
            <button class="btn-default" (click)="dateSelector.cancel(); datePopover.dismiss({}, 'cancel', false)">
              Cancel
            </button>
            <button class="btn-primary" (click)="dateSelector.confirm(); datePopover.dismiss({}, 'confirm', false)">
              Done
            </button>
          </div>
        </ion-datetime>
      </ng-template>
    </ion-popover>
  </div>
}
